<template>
  <div>
    <a-card>
      <a-form layout="inline" ref="searchForm" :model="form.searchForm" style="margin-bottom: 20px;">
        <a-form-item label="任务状态" name="takType">
          <a-select
            style="width: 140px"
            v-model:value="form.searchForm.status"
            :options="optData.fileStatusOpt"
          >
          </a-select>
        </a-form-item>
        <a-form-item label="关键字" name="keywords">
          <a-input style="width: 200px" ref="keywords" placeholder="根据上传编号/任务名称/子任务编号查询" v-model:value="form.searchForm.keywords" autocomplete="off">
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="search">查询</a-button>
        </a-form-item>
      </a-form>
      <a-table :dataSource="upload.list" :columns="columns" :pagination="false">
        <template v-slot:taskStatus="{ record }">
          {{ statusTrans(record.state, fileStatus) }}
        </template>
      </a-table>
      <div class="mt20">
        <a-pagination
        v-model:current="upload.page.num"
        show-quick-jumper
        :pageSize=upload.page.size
        :total="upload.page.total"
        :show-total="total => `共 ${total} 条`"
        @change="getUploadList"
      ></a-pagination>
      </div>
    </a-card>
  </div>
</template>

<script>
const columns = [
  {
    title: '上传编号',
    dataIndex: 'number'
  },
  {
    title: '子任务编号',
    dataIndex: 'labelTaskSubNumber'
  },
  {
    title: '任务名称',
    dataIndex: 'labelTaskName',

  },
  {
    title: '上传人',
    dataIndex: 'createUserName',
  },
  {
    title: '状态',
    dataIndex: 'state',
    slots: { customRender: 'taskStatus' }
  },
  {
    title: '上传时间',
    dataIndex: 'createTime',
  },
]

import {reactive, onMounted} from "vue";
import {useRoute, useRouter} from 'vue-router'
import { message } from 'ant-design-vue';
import { useStore } from '@/store/index2'
import {statusToCn} from '@/filters'

import {uploadList} from '@/api/taskRelease'


export default{
  components:{
    
  },
  setup(){
    const router = useRouter()
    const route = useRoute()
    let upload = reactive({
      list:[],
      page:{
        num:1,
        size:10,
        total:0
      },
    })



    let store = useStore()


    let { fileStatus } = store

    function statusTrans(state, stateObj){
      return statusToCn(state, stateObj)
    }
  
    let form = reactive({
      searchForm:{
        status:'',
        keywords:'',
      }
    })

    let searchForm = reactive({
      status:'',
      keywords:'',
    })
    
    // 搜索表单  select下拉列表
    let optData = reactive({
      fileStatusOpt:[{label:'全部',value:''}],
    })

    for(let prop in fileStatus){
      optData.fileStatusOpt.push({
        value:prop,
        label:fileStatus[prop]
      }) 
    }


    //  搜索
    const search = ()=>{
      upload.page.num = 1
      getUploadList()
    }

    //  任务列表  
    const getUploadList = async ()=>{
      upload.list = []
      let params = {
        groupId:JSON.parse(localStorage.getItem('westCurrentRole')).teamId,
        keyword:form.searchForm.keywords,
        pageNum:upload.page.num,
        pageSize:upload.page.size,
        states: form.searchForm.status ? [form.searchForm.status] : [],
        //visibility:'',
      }
      const {data:res} = await uploadList(params)
        const list = [...res.data.records]
        upload.list = list
        upload.page.total = res.data.total

    }

    // 属性值 转中文
    function statusTrans(state, stateObj){
      return statusToCn(state, stateObj)
    }
    

    onMounted(() => {
      getUploadList()
    })


    return{   
      form,
      searchForm,
      columns,
      upload,
      optData,
      fileStatus,
      getUploadList,
      search,
      statusTrans
    }
  }
}
</script>


<style>

</style>
